import { ActivityIndicator, Pressable, StyleSheet, View } from 'react-native';
import { Typography } from 'ucl';

import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

type CartFooterContinueButtonProps = {
  disabled?: boolean;
  isLoading?: boolean;
  onPress?: () => void;
};

export const CartFooterContinueButton = ({
  disabled = false,
  isLoading = false,
  onPress,
}: CartFooterContinueButtonProps) => {
  const label = t('continue');
  const isDisabled = disabled || isLoading;

  const handlePress = () => {
    if (isDisabled) {
      return;
    }

    if (onPress) {
      onPress();
    }
  };

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={label}
      accessibilityState={{ disabled: isDisabled, busy: isLoading }}
      disabled={isDisabled}
      onPress={handlePress}
      style={({ pressed }) => [
        styles.button,
        pressed && !isDisabled && styles.buttonPressed,
        isDisabled && styles.buttonDisabled,
      ]}
      testID="continue-order"
    >
      <View style={styles.content}>
        {isLoading && (
          <ActivityIndicator
            size="small"
            color={isDisabled ? primitive.$disabledText : primitive.$white}
          />
        )}
        <Typography style={[styles.text, isDisabled && styles.textDisabled]}>{label}</Typography>
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    width: '100%',
    minHeight: spacing.$12,
    borderRadius: 9999,
    backgroundColor: primitive.$fieryRed,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.$5,
  },
  buttonPressed: {
    backgroundColor: primitive.$fieryRedPressed,
  },
  buttonDisabled: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: primitive.$blackOpacity30,
  },
  text: {
    fontSize: 16,
    lineHeight: 20,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.$white,
  },
  textDisabled: {
    color: primitive.$disabledText,
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
});
